import React, { useState, useEffect } from 'react';
import Header from 'components/Header';
import { Input } from '@mantine/core';
import { useDebouncedValue } from '@mantine/hooks';
import { useSearchParams } from 'react-router-dom';

import PrimaryButton from 'components/primaryButton';
import ChannelCard from './components/channelCard';
import CreateChannel from './components/createChannel';
import ChannelCardLoader from './components/channelCardLoader';

import useGetAllChannels from './hooks/useGetAllChannels';

import { ReactComponent as EmptyTaskIlls } from 'assets/images/emptyTaskIlls.svg';
import { ReactComponent as SearchIcon } from 'assets/icons/searchIcon.svg';

export default function Taskboard() {
  const [isCreateChannelModalOpen, setCreateChannelModalOpen] = useState(false);
  const [searchText, setSearchtext] = useState('');

  const [searchParams, setSearchParams] = useSearchParams();

  const [debounced] = useDebouncedValue(searchText, 300);

  const getAllChannelsData = useGetAllChannels(searchParams.get('search'));

  useEffect(() => {
    if (debounced) {
      setSearchParams({ search: debounced });
    } else {
      setSearchParams();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debounced]);

  return (
    <div className='px-5'>
      <div className='flex justify-end items-center mt-6'>
        <Header />
      </div>
      <div className='flex justify-between items-center mt-4 mb-7'>
        <div>
          <p className='text-xl text-A8A8A8'>
            Projects &#60;{' '}
            <span className='text-gray font-semibold'> Task board</span>
          </p>
        </div>
        <div className='flex space-x-7 items-center'>
          <Input
            icon={<SearchIcon />}
            value={searchText}
            onChange={(e) => setSearchtext(e.target.value)}
            placeholder='Search'
            classNames={{
              wrapper: 'border-primary border-b',
              input: 'w-48 bg-light-bg border-none',
            }}
          />
          {getAllChannelsData?.data?.data?.length ||
          searchParams.get('search') ? (
            <button onClick={() => setCreateChannelModalOpen(true)}>
              <PrimaryButton>+ Create channel</PrimaryButton>
            </button>
          ) : null}
        </div>
      </div>
      {getAllChannelsData?.isLoading ? (
        <div className='flex flex-wrap'>
          <ChannelCardLoader />
          <ChannelCardLoader />
          <ChannelCardLoader />
        </div>
      ) : (
        <>
          {!getAllChannelsData?.data?.data?.length ? (
            <div className='bg-white shadow-lg border border-gray border-opacity-10 min-h-[70vh] mt-2 rounded-lg'>
              <div className='flex flex-col justify-center items-center h-[70vh]'>
                <EmptyTaskIlls />
                <p className='text-gray3 text-xl pt-4'>
                  Seems like you don’t have any channels to show
                </p>
                {searchParams.get('search') ? null : (
                  <button
                    className='mt-7'
                    onClick={() => setCreateChannelModalOpen(true)}
                  >
                    <PrimaryButton>Create channel</PrimaryButton>
                  </button>
                )}
              </div>
            </div>
          ) : (
            <div className='grid grid-cols-3 '>
              {getAllChannelsData?.data?.data?.map((item) => {
                return <ChannelCard key={item?.id} item={item} />;
              })}
            </div>
          )}
        </>
      )}

      {isCreateChannelModalOpen && (
        <CreateChannel
          isModalOpen={isCreateChannelModalOpen}
          setIsModalOpen={setCreateChannelModalOpen}
          name='Create'
        />
      )}
    </div>
  );
}
